// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__slvuY","expireSoon":"styles_expireSoon__2dwy9"};